import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { close } from 'redux/modules/modals/actions';

class Modals extends React.Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    componentDidMount() {
        this.props.history.listen(() => this.props.close());
    }

    render() {
        return this.props.activeModal;
    }
}

const mapStateToProps = (state) => state.modals;

export default connect(
    mapStateToProps,
    { close }
)(withRouter(Modals));
